module.exports = __webpack_public_path__ + "img/spins_page_900.7e6bbc59.png";